// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__-Msj-","shimmer":"styles_shimmer__3bgtv"};